import {
	exposeCreditCardModalToWindow,
	exportPaymentMethodsToWindow,
} from '../../components/payments';
import {tracking} from "@bark/bark-core";
import { generateWalletOptions } from "../../helpers/payments/helpers";

export default function PaymentDetailsSettings() {
	exposeCreditCardModalToWindow();
	exportPaymentMethodsToWindow();

	function Api(sellerProfileId) {
		const instanceVars = {
			getImageSourceForCreditCardLogo: (cardType, dark) => {
				if (typeof dark === 'undefined') {
					dark = false;
				}
				const cardtype = cardType.replace(/\s+/g, '').toLowerCase();
				if (dark) {
					return (
						Bark.ENV.static_images_url +
						'frontend-v2/settings/billing-' +
						cardtype +
						'-dark-v2.svg'
					);
				} else {
					return (
						Bark.ENV.static_images_url +
						'frontend-v2/settings/billing-' +
						cardtype +
						'-v2.svg'
					);
				}
			},

			initCardModalListeners: () => {
				$('.js-open-payment-card-modal')
					.off('click.open')
					.on('click.open', (e) => {
						e.preventDefault();
						$('#cardAddSuccess').addClass('d-none').removeClass('d-flex');
						app.cardEntrySuccess = app.defaultCardEntrySuccess;
						window.BarkPaymentsCardModal.showCardModal($cardModal, {
							clearModal: true,
							...generateWalletOptions(true, {
								isOnlySavingCard: true,
								userId: Bark.USER.userId,
								disableWallets: {
									paypal: true,
								},
								onWalletSetupComplete: () => {
									Bark.hideLoading();
									self.getBillingInfo();
								}
							})
						});
					});
			},

			defaultCardEntrySuccess: (token) => {
				const self = this;
				Bark.showLoading();
				$('#cardAddSuccess').addClass('d-none').removeClass('d-flex');

				window.BarkPaymentsCardModal.confirmSetupIntent(
					$cardModal.data('user-id'),
					token.id,
				)
					.then(() => {
						Bark.hideLoading();
						self.getBillingInfo();
					})
					.catch(() => {
						Bark.hideLoading();
						window.BarkPaymentsCardModal.showModalErrorText(
							$cardModal,
							_t(
								'seller_settings_credits:payment-card-modal.errors.card-details-message',
							),
						);
						window.BarkPaymentsCardModal.showCardModal($cardModal, generateWalletOptions(true, {
							isOnlySavingCard: true,
							userId,
							disableWallets: {
								paypal: true,
							},
							onWalletSetupComplete: () => {
								Bark.hideLoading();
								self.getBillingInfo();
							}
						}));
					});
			},

			displayCard: (templateVars) => {
				const template = $('#carddisplay').text();
				const renderTemplate = Handlebars.compile(template);

				$('#cardLoading').addClass('d-none').removeClass('d-flex');
				$('#cardholder')
					.html(renderTemplate(templateVars))
					.removeClass('d-none')
					.addClass('d-flex');
				this.initCardModalListeners();
			},

			getBillingInfo: async () => {
				var t = this;
				$('#cardLoading').removeClass('d-none').addClass('d-flex');
				$('#cardholder').addClass('d-none').removeClass('d-flex');

				const paymentMethod = await getPrimaryPaymentMethod(sellerProfileId);

				if (paymentMethod) {
					window.BarkPaymentsCardModal.setHeaderText(
						$cardModal,
						_t('seller_settings_credits:payment-card-modal.update-title'),
					);
					window.BarkPaymentsCardModal.setConfirmText(
						$cardModal,
						_t('seller_settings_credits:payment-card-modal.update-button'),
					);
					var cardChargeHelpTrans = _t(
						'seller_settings_billing:card-info.card-charge-help',
						{
							card_last_four:
								'<strong class="js-card-last-four">' +
								paymentMethod.card_number +
								'</strong>',
						},
					);
					this.displayCard({
						cardtype: paymentMethod.card_brand.toLowerCase(),
						modalTarget: 'payment-card-modal',
						expiry:
							paymentMethod.card_expiry_month +
							'/' +
							paymentMethod.card_expiry_year.substr(-2),
						lastfour: paymentMethod.card_number,
						cardsrc: t.getImageSourceForCreditCardLogo(
							paymentMethod.card_brand.toLowerCase(),
						),
						cardChargeHelpTrans: cardChargeHelpTrans,
						cardsrcdark: t.getImageSourceForCreditCardLogo(
							paymentMethod.card_brand.toLowerCase(),
							true,
						),
					});
				} else {
					window.BarkPaymentsCardModal.setHeaderText(
						$cardModal,
						_t('seller_settings_credits:payment-card-modal.add-title'),
					);
					window.BarkPaymentsCardModal.setConfirmText(
						$cardModal,
						_t('seller_settings_credits:payment-card-modal.confirm-button'),
					);
					this.displayCard({ nocard: true });
				}
			},
		};

		let externalPaymentId;

		const attemptPayment = async (handler) => {
			modalManager.showLoading(
				_t('seller_settings_billing:failed-subscription-payment.attempting-payment'),
			);

			try {
				await handler();
				modalManager.hideLoading();
				modalManager.showSuccessModal(
					_t('seller_settings_billing:failed-subscription-payment.payment-successful'),
					'',
				);
				window.setTimeout(() => {
					document.location.reload();
				}, 2000);
			} catch (e) {
				console.error(e);
				bugsnagClient && bugsnagClient.notify(e);
				window.BarkPaymentsCardModal.showModalErrorText(
					$cardModal,
					_t('seller_settings_billing:failed-subscription-payment.problem-with-card'),
				);
				// Cannot enable APMs at this time because we do not know the payment amount
				window.BarkPaymentsCardModal.showCardModal($cardModal, { enableWallets: false });

				app.cardEntrySuccess = async (token) => {
					await attemptPayment(async () => {
						const payment = await window.BarkPaymentsCardModal.getPaymentInfo(
							userId,
							externalPaymentId,
						);
						const intentSecret = payment.data.attributes.client_secret;
						await window.BarkPaymentsCardModal.retryIntent(intentSecret, null, token.id);
					});
				};

				modalManager.hideLoading();
			}
		};

		instanceVars.isMostRecentInvoiceFailed = async () => {
			try {
				const params = new URLSearchParams(location.search);
				const type = params.get('fpt') || 'ep';

				const result = await Bark.api(
					`/user/${userId}/billing/payment-error/invoice/latest?type=${type}` ,
				);

				if (result?.data) {
					externalPaymentId = result.data.attributes.external_payment_id;
					const subtotal = Intl.NumberFormat(Bark.ENV.lang, {
						style: 'currency',
						currency: result.data.attributes.currency,
					}).format(result.data.attributes.subtotal);

					const instructionKey =
						result.data.attributes.vat_rate > 1
							? 'seller_settings_billing:failed-subscription-payment.summary-with-tax'
							: 'seller_settings_billing:failed-subscription-payment.summary';

					$('.js-failed-payment-summary').text(_t(instructionKey, { subscription_type: result.data.attributes.type, amount: subtotal }));

					$('.js-retry-failed-payment-link')
						.off('click.load')
						.on('click.load', async () => {
							tracking('payment-details', 'retry payment details');

							await attemptPayment(async () => {
								const paymentMethod = await getPrimaryPaymentMethod(sellerProfileId);
								const payment = await window.BarkPaymentsCardModal.getPaymentInfo(
									userId,
									externalPaymentId,
								);
								const intentSecret = payment.data.attributes.client_secret;
								await window.BarkPaymentsCardModal.retryIntent(
									intentSecret,
									paymentMethod.id,
								);
							});
						});

					const container = $('.js-failed-subscription');
					container
						.css({ overflow: 'hidden', height: 0, opacity: 0 })
						.removeClass('d-none');
					const bodyHeight = $(
						'.js-failed-subscription-body',
						container,
					)[0].getBoundingClientRect().height;
					container
						.delay(10)
						.animate({ height: bodyHeight, opacity: 1 }, 300, 'swing', () => {
							container.css({ height: 'auto' });
						});
				}
			} catch (e) {
				console.error(e);
				bugsnagClient && bugsnagClient.notify(e);
			}
		};

		Object.assign(this, instanceVars);

		this.cardEntrySuccess = this.defaultCardEntrySuccess;

		const app = this;
		const cardModalSelector = '.js-card-payment-modal';
		const $cardModal = window.BarkPaymentsCardModal.initCardModal(
			cardModalSelector,
			(token) => {
				app.cardEntrySuccess(token);
			},
		);
		const userId = $cardModal.data('user-id');
	}

	Bark.api('seller/self',
        {},
        async (data) => {
		const sellerProfileId = data.data.spf_id;
		let api = new Api(sellerProfileId);
		await api.getBillingInfo(sellerProfileId);
        api.isMostRecentInvoiceFailed();
	});


	var delinquent = $('#delinquent-seller-modal');
	if (delinquent.length > 0) {
		delinquent.modal('show');
	}
}
